<footer class="main-footer">
  <div class="float-right d-none d-sm-block">
    <b>Version</b> 2.0.0
  </div>
  <strong>Sindicato dos Trabalhadores em Instituições Federais de Educação Profissional e Tecnológica - GOIÁS <a href="http://sintef.org.br">Sintef-GO</a>.</strong>
</footer>
